import React, { useState, useEffect } from "react";
import "./Hero.css"; // Create a CSS file for styling

const Hero = () => {
  const images = [
    {
      src: "hero1.jpeg",
      text: "WELCOME TO STEELRYX Steel works LLC",
      para: "One of the leading fabrication and engineering solution companies in the UAE. Our company's strength is that we can provide a full range of services, including design, fabrication, supply, and installation",
    },
    {
      src: "hero2.jpeg",
      text: "WELCOME TO STEELRYX Steel works LLC",
      para: "One of the leading fabrication and engineering solution companies in the UAE. Our company's strength is that we can provide a full range of services, including design, fabrication, supply, and installation",
    },
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000); // Change image every 3 seconds (adjust as needed)

    return () => {
      clearInterval(interval);
    };
  }, [images.length]);

  return (
    <div className="hero-section">
      {images.map((image, index) => (
        <div
          key={index}
          className={`hero-slide ${
            index === currentImageIndex ? "active" : ""
          }`}
        >
          <img src={image.src} alt={`${index + 1}`} />
          <div className="text-overlay">
            <h2>{image.text}</h2>
            <p>{image.para}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Hero;
